import React, { memo } from 'react'
import { NewsFeedFilters } from './NewsFeedFilters'
import { PersonalViewFilters, PersonalViewFiltersState } from './PersonalViewFilters'

interface PostFiltersProps {
  user_groups: string[] | null
  consolidationFilterOptions: Record<string, string[]>
  isDisabled: boolean
  uid: string

  openSearchModalHandler: () => void
  isShowAllMyPosts: boolean
  isPersonalView: boolean
  onViewChange: (isPersonal: boolean) => void
  onPersonalFiltersChange?: (filters: PersonalViewFiltersState) => void
}

export const PostFilters = memo(
  ({
    user_groups,
    consolidationFilterOptions,
    isDisabled,
    uid,
    isShowAllMyPosts,
    openSearchModalHandler,
    isPersonalView,
    onViewChange,
    onPersonalFiltersChange,
  }: PostFiltersProps) => {
    // Display different filters depending on the mode
    if (isPersonalView) {
      return (
        <PersonalViewFilters
          isPersonalView={isPersonalView}
          onViewChange={onViewChange}
          isDisabled={isDisabled}
          onFiltersChange={onPersonalFiltersChange}
        />
      )
    }

    return (
      <NewsFeedFilters
        user_groups={user_groups}
        consolidationFilterOptions={consolidationFilterOptions}
        isDisabled={isDisabled}
        uid={uid}
        isShowAllMyPosts={isShowAllMyPosts}
        openSearchModalHandler={openSearchModalHandler}
        isPersonalView={isPersonalView}
        onViewChange={onViewChange}
      />
    )
  }
)
